<template>
  <div>
    <CRUDCriteria :showReset='true' :showSearch='false' :resetCriteria='resetCriteria'>
      <template v-slot:criteriaRows>
        <div class='mt-0 ml-6 mr-6 pa-0'>
          <v-row class='ma-n4'>
            <v-col cols="4" class="pt-0 pb-0">
            <v-text-field class="input-text-size" label="Wildcard Search - PID, TaxID, Name"
              v-model="criteriaState.wildCard"
              @input="searchByTimeOut" />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <v-select
              class="input-text-size"
              label="Resale Year"
              :items="saleYearItems"
              v-model="criteriaState.saleYear"
              item-text="name"
              item-value="value"
              @change="searchByCriteria" />
            </v-col>
          </v-row>
        </div>
      </template>
    </CRUDCriteria>
  </div>
</template>
<script>
import {
  mapGetters, mapMutations, mapState,
} from 'vuex';
import CRUDCriteria from '../../../../common/base/crud-2.0/CRUDCriteria.vue';
import { SEARCH_DEBOUNCE_TIMER } from '../../../common-utils/constants';

export default {
  name: 'ResalePropertyListCriteria',
  props: {
    baseCrudKey: {
      type: String,
      default: 'ResalePropertyList',
    },
  },
  components: {
    CRUDCriteria,
  },
  data() {
    return {
      delayTimerId: null,
    };
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      saleYearList: (state) => state.tax.juneResale.saleYearList,
      latestSaleYear: (state) => state.tax.juneResale.latestSaleYear,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    saleYearItems() {
      return [{ name: 'All Years', value: 0 }, ...(this.saleYearList || [])];
    },
  },

  methods: {
    ...mapMutations('base/crud', ['setCriteria']),
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        this.searchByCriteria();
      }, SEARCH_DEBOUNCE_TIMER);
    },
    searchByCriteria() {
      // the grid pages server-side on skip/limit, so a new filter has to go back to the
      // first page - otherwise searching from page 2 asks for rows 101+ of a 4-row result
      // and the grid comes back empty
      this.setCriteria([this.baseCrudKey, { skip: 0 }, true]);
      this.$emit('loadCRUDList');
    },
    resetCriteria() {
      // CRUDCriteria's default reset is a full page reload, which would also throw away the
      // penalty date and the selected list action on this screen
      this.setCriteria([this.baseCrudKey, {
        wildCard: null,
        saleYear: this.latestSaleYear || null,
        skip: 0,
      }, true]);
      this.$emit('loadCRUDList');
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
